import { inject, injectable } from "tsyringe";
import { Observable } from "rxjs";
import { HttpClient } from "src/infra/http/client";
import { autoBind } from "src/shared/decorators/autobind";
import { CampaignBanner } from "src/containers/home/types";

@injectable()
export class AdvertisingRepository {
    constructor(@inject("HttpClient") private http: HttpClient) {}

    @autoBind
    getCampaigns(): Observable<CampaignBanner[]> {
        const headers = this.http.httpUtils.getMsBaseHeaders(
            window.userIdentity,
            "MEP"
        );
        const endpoint = AdvertisingRepository.getCampaingnsUrl();
        return this.http.getJSON<CampaignBanner[]>(endpoint, {
            isPublicRequest: false,
            customHeader: {
                ...headers,
                ...this.http.httpUtils.getPrivateHeader(),
            },
        });
    }

    static getCampaingnsUrl(): string {
        return "insureds/me/banner";
    }
}
